module.exports = __webpack_public_path__ + "img/tiger-machine-panel-light-1.71499319.svg";